import { Card } from "@/components/Card/card";
import { VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import AddStepperNavigationStepItem from "./AddStepperNavigationStepItem";
import AddStepperNavigationStepItemNoStepper from "./AddStepperNavigationStepItemNoStepper";

type Step = {
  label: string;
  hash: string;
  isError?: boolean;
};

type Props = {
  /** タイトル */
  title: string;
  /** ベースリンク */
  baseLink: string;
  /** 現在のハッシュ */
  currentHash: string;
  /** エラー有無 */
  isError?: boolean;
  /** ステップリスト */
  steps: Step[];
  /** No Stepper の場合は Step の制御ではなく 通常の Navigation の挙動になる */
  hasStepper?: boolean;
};

const AddStepperNavigation = ({
  title,
  baseLink,
  currentHash,
  isError,
  steps,
  hasStepper = true,
}: Props) => {
  return (
    <Card className="h-full min-w-[300px]">
      <VStack className="gap-6 p-6">
        <div className="flex flex-col items-start gap-1.5 self-stretch px-0">
          <Text variant="h3">{title}</Text>
        </div>
        <VStack className="gap-2">
          {steps.map((step, index) =>
            hasStepper ? (
              <AddStepperNavigationStepItem
                key={step.hash}
                baseLink={baseLink}
                currentHash={currentHash}
                isError={step.isError || isError}
                steps={steps}
                step={step}
                stepIndex={index}
              />
            ) : (
              <AddStepperNavigationStepItemNoStepper
                key={step.hash}
                baseLink={baseLink}
                currentHash={currentHash}
                isError={step.isError || isError}
                steps={steps}
                step={step}
                stepIndex={index}
              />
            ),
          )}
        </VStack>
      </VStack>
    </Card>
  );
};

export default AddStepperNavigation;
